import * as stylex from '@stylexjs/stylex';
import { createFileRoute, Navigate } from '@tanstack/react-router';

import { EmptyState, Heading, Paragraph } from '@/libs/serenity-ui';

export const Route = createFileRoute('/_minimal/info')({
  component: RouteComponent,
  staticData: {
    minimal: {
      showLogo: true,
    },
  },
});

function RouteComponent() {
  const routeContext = Route.useRouteContext();

  if (!routeContext.info) {
    return <Navigate to="/" />;
  }

  return (
    <EmptyState style={styles.container}>
      <Heading color="placeholder">{routeContext.info.heading}</Heading>
      <Paragraph color="placeholder">{routeContext.info.details}</Paragraph>
    </EmptyState>
  );
}

const styles = stylex.create({
  container: {
    height: '100%',
    justifyContent: 'flex-start',
    paddingTop: 80,
  },
});
